import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const AdminLogin: React.FC = () => {
  const [token, setToken] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation() as any;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');
    try {
      const res = await fetch('/api/admin/verify', {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        sessionStorage.setItem('adminToken', token);
        const redirectTo = location.state?.from?.pathname || '/admin/language-intros';
        navigate(redirectTo, { replace: true });
      } else if (res.status === 401) {
        setStatus('Nieprawidłowy token.');
      } else {
        setStatus('Błąd logowania.');
      }
    } catch {
      setStatus('Błąd sieci.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="results-section">
      <div className="results-container">
        <h1 className="results-title">Logowanie administratora</h1>
        <form onSubmit={handleSubmit} className="product-card" style={{ padding: 16 }}>
          <div className="product-content" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input
              type="password"
              placeholder="Wklej token admina"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="admin-input"
              style={{ flex: 1 }}
            />
            <button className="submit-button" type="submit" disabled={loading || !token}>
              {loading ? 'Logowanie...' : 'Zaloguj'}
            </button>
          </div>
          {status && (
            <div className={`status-message ${status.includes('Błąd') || status.includes('Nieprawidłowy') ? 'error' : 'info'}`} style={{ marginTop: 12 }}>
              {status}
            </div>
          )}
        </form>
      </div>
    </section>
  );
};

export default AdminLogin;
